import { Button } from "antd";
import { ReactNode } from "react";
import AlertRedIcon from "../assets/icons/AlertRedIcon";
import AlertYellowIcon from "../assets/icons/AlertYellowIcon";
import DeleteIconRed from "../assets/icons/DeleteIconRed";
import LeaveRedIcon from "../assets/icons/LeaveRedIcon";
import SuccessGreenIcon from "../assets/icons/SuccessGreenIcon";
import CustomModal from "../components/ui/CustomModal";

export interface ModalConfirmProps<
  DataT = never,
  TypeT =
    | "SUCCESS"
    | "ADD"
    | "UPDATE"
    | "VIEW"
    | "CONFIRM"
    | "CONFIRM_FOR_APPROVAL",
> {
  open: boolean;
  alertRedIcon?: boolean;
  alertYellowIcon?: boolean;
  successGreenIcon?: boolean;
  cancelButton?: boolean;
  deleteButton?: boolean;
  leaveButton?: boolean;
  raiseButton?: boolean;
  rejectButton?: boolean;
  approvedButton?: boolean;
  viewTicketButton?: boolean;
  createButton?: boolean;
  okayButton?: boolean;
  viewButton?: boolean;
  successfullOkayButton?: boolean;
  yesCancelButton?: boolean;
  yesCloseButton?: boolean;
  handleClose: (val?: any) => void;
  handleAction?: (val?: any) => void;
  handleViewTicket?: (val?: any) => void;
  handleViewTicketAction?: (val?: any) => void;
  type?: TypeT;
  data?: DataT;
  title?: ReactNode;
  createUpdateBtnName?: ReactNode;
  subTitle?: ReactNode;
  loading?: boolean;
  children?: ReactNode;
  centerOkButton?: boolean;
  viewButtonContent?: ReactNode;
}

export default function CommonModalLayout({
  title,
  alertRedIcon,
  alertYellowIcon,
  successGreenIcon,
  cancelButton,
  deleteButton,
  leaveButton,
  raiseButton,
  rejectButton,
  approvedButton,
  viewTicketButton,
  okayButton,
  createButton,
  successfullOkayButton,
  subTitle,
  createUpdateBtnName,
  viewButton,
  yesCancelButton,
  yesCloseButton,
  handleClose,
  handleAction,
  handleViewTicket,
  handleViewTicketAction,
  children,
  type,
  data,
  loading,
  centerOkButton,
  viewButtonContent,
  ...rest
}: ModalConfirmProps) {
  return (
    <>
      <CustomModal
        {...rest}
        handleClose={handleClose}
        width={400}
        footer={null}
      >
        <div className="p-1 rounded flex items-center justify-center">
          {alertRedIcon && <AlertRedIcon />}
          {alertYellowIcon && <AlertYellowIcon />}
          {successGreenIcon && <SuccessGreenIcon />}
        </div>

        <div className="text-[17px] font-semibold text-center mt-6">
          {title}
        </div>
        <div className="my-2 mt-3 text-[#5E718D] text-center mb-6">
          {subTitle}
        </div>
        {children}

        <div
          className={`flex w-full mt-3 ${
            centerOkButton ? "justify-center" : "justify-between "
          }`}
        >
          <div>
            {cancelButton && (
              <Button
                onClick={() => handleClose()}
                className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFFFFF] rounded-md outline outline-1 outline-offset-[-1px] outline-[#D7DFE9] inline-flex items-center gap-2.5 text-sm font-medium"
              >
                <span className=" text-sm font-medium text-[#455468]">
                  Cancel
                </span>
              </Button>
            )}

            {viewButton && (
              <Button
                onClick={() => handleViewTicket && handleViewTicket()}
                className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFFFFF] rounded-md outline outline-1 outline-offset-[-1px] outline-[#D7DFE9] inline-flex items-center gap-2.5 text-sm font-medium"
              >
                <span className=" text-sm font-medium text-[#455468]">
                  {viewButtonContent || "View Ticket"}
                </span>
              </Button>
            )}
          </div>

          {successfullOkayButton && (
            <Button
              onClick={() => {
                handleClose();
                handleAction && handleAction();
              }}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF1EB] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FE7235]">
                Okay
              </div>
            </Button>
          )}

          {deleteButton && (
            <Button
              loading={loading}
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF5F4] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FF3838]">
                <div className="w-4 h-4 flex items-center justify-center">
                  <DeleteIconRed />
                </div>
                {/* Yes, Delete */}
                Delete
              </div>
            </Button>
          )}

          {leaveButton && (
            <Button
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF5F4] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FF3838]">
                <div className="w-4 h-4 flex items-center justify-center">
                  <LeaveRedIcon />
                </div>
                {/* Yes, Leave */}
                Leave
              </div>
            </Button>
          )}

          {createButton && (
            <Button
              loading={loading}
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF1EB] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FE7235]">
                {createUpdateBtnName}
              </div>
            </Button>
          )}

          {raiseButton && (
            <Button
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF1EB] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FE7235]">
                Raise
              </div>
            </Button>
          )}

          {rejectButton && (
            <Button
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF5F4] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FF3838]">
                Reject
              </div>
            </Button>
          )}

          {approvedButton && (
            <Button
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFFBEB] rounded-md border-[1px] border-[#FFE176] inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FFC700]">
                Approved
              </div>
            </Button>
          )}
        </div>

        {viewTicketButton && (
          <div className="flex justify-center w-full mt-3">
            <Button
              onClick={() => handleViewTicketAction && handleViewTicketAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFFFFF] rounded-md outline outline-1 outline-offset-[-1px] outline-[#D7DFE9] inline-flex items-center gap-2.5 text-sm font-medium"
            >
              <span className=" text-sm font-medium text-[#455468]">
                View Ticket
              </span>
            </Button>
          </div>
        )}

        {okayButton && (
          <div className="flex justify-center w-full mt-3">
            <Button
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF1EB] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FE7235]">
                Okay
              </div>
            </Button>
          </div>
        )}

        {yesCancelButton && (
          <div className="flex justify-between w-full mt-3">
            <Button
              onClick={() => handleClose()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFFFFF] rounded-md outline outline-1 outline-offset-[-1px] outline-[#D7DFE9] inline-flex items-center gap-2.5 text-sm font-medium"
            >
              <span className=" text-sm font-medium text-[#455468]">No</span>
            </Button>

            <Button
              loading={loading}
              disabled={loading}
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF5F4] disabled:bg-[#FFF5F4] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FF3838]">
                Yes
              </div>
            </Button>
          </div>
        )}

        {yesCloseButton && (
          <div className="flex justify-between w-full mt-3">
            <Button
              onClick={() => handleClose()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFFFFF] rounded-md outline outline-1 outline-offset-[-1px] outline-[#D7DFE9] inline-flex items-center gap-2.5 text-sm font-medium"
            >
              <span className=" text-sm font-medium text-[#455468]">No</span>
            </Button>

            <Button
              loading={loading}
              disabled={loading}
              onClick={() => handleAction && handleAction()}
              className="px-3.5 min-w-[76px] justify-center py-2 bg-[#FFF5F4] disabled:bg-[#FFF5F4] rounded-md outline outline-1 outline-offset-[-1px] outline-red-300 inline-flex justify-start items-center gap-2.5 overflow-hidden"
            >
              <div className="flex items-center gap-2 text-sm font-medium text-[#FF3838]">
                Yes
              </div>
            </Button>
          </div>
        )}
      </CustomModal>
    </>
  );
}
